
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import Group from 'vux/src/components/group/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import FormPreview from 'vux/src/components/form-preview/index.vue'

import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import XHeader from 'vux/src/components/x-header/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


export default {

components: {
Tab,
TabItem,
Cell,
Divider,
XButton,
Group,
Flexbox,
FlexboxItem,
XHeader
},

props: ['memberId'],

data() {
return {
currentUser: 'newbie',
childList: {
newbie: {
currentPage: 1,
total: 0,
list: []
},
upper: {
currentPage: 1,
total: 0,
list: []
},
agent: {
currentPage: 1,
total: 0,
list: []
}
}
}
},
filters: {
userLevel(value) {
let al = value.agent_level;
let isAgent = value.is_agent;
let ul = value.level;
if (isAgent > 0) {
return al;
} else {
return ul === 1 ? '普通用户' :
(ul === 2 ? '初级用户' :
(ul === 3 ? '中级用户' :
(ul === 4 ? '高级用户' : '')));
}
}
},
computed: {
isShowLoadMoreBtn() {
return this.childList[this.currentUser]['total'] >= ((this.childList[this.currentUser]['currentPage'] - 1) * this.childList[this.currentUser]['perPage'])
}
},
created: function () {
document.title = '推荐列表'
this.getList();
},

mounted: function () {
this.$nextTick(function () {
})
},

methods: {
handleChange(i) {
this.currentUser = i === 0 ? 'newbie' :
(i === 1 ? 'upper' :
(i === 2 ? 'agent' : ''));

console.log(`切换到${i}, 当前标识为${this.currentUser}`);
console.log('长度', this.childList[this.currentUser]['list'].length);
if (this.childList[this.currentUser]['list'].length === 0) {
console.log('检测到数据为空，获取一次列表数据');
this.getList()
}
},
getList() {
const url = this.tianYiWebUrl + '/wechat/uc/ajaxGetListByType';
this.btnShowLoading = true;
this.$http.get(url, {
params: {
type: this.currentUser,
uid: this.memberId,
page: this.childList[this.currentUser]['currentPage']
}
}).then(r => {
console.log(r);
let res = r.data;
if (res.code === 200) {
this.childList[this.currentUser]['list'] = [...this.childList[this.currentUser]['list'], ...res.data.data];
this.childList[this.currentUser].currentPage = +res.data.current_page + 1;
this.childList[this.currentUser]['perPage'] = res.data.per_page;
this.childList[this.currentUser]['total'] = res.data.total;
this.btnShowLoading = false;
}
})
},
getMore() {
this.getList()
}
}
}



// WEBPACK FOOTER //
// ./src/components/uc/ChildList.vue